export function initScrollToTarget(links: HTMLElement|NodeListOf<HTMLElement>) {

	let allLinks: HTMLElement[] = [];

	if (links instanceof NodeList) {
		allLinks = Array.from(links);
	} else {
		allLinks = [links];
	}

	allLinks.forEach(
		(link) => {
			link.addEventListener('click', (e) => {
				let targetSelector = link.getAttribute('href');
				if (targetSelector) {
					try {
						let targetEl = document.querySelector(targetSelector);
						if (targetEl) {
							targetEl.scrollIntoView({
								behavior: 'smooth',
								block: 'start',
							})
						}
					} catch (e) {
						console.warn(e);
						;
					}
				}
				e.preventDefault();
			});
		}
	)

}
